import { IModel, IAttribute, IViolation, ModelConstants } from 'shell-models-lib';
import { Metamodel } from 'app/model/base/model';
import { ScriptFlowActivity } from './script-flow.activity';
import { AzureDataLakeAnalyticsLinkedService } from 'app/model/linkedservice/azure-data-lake-analytics.linkedservice';
import { createParameterConfigurationValidator } from 'app/model/adapters/linkedservices/parameter-config.util';
import { ParameterConfig } from 'app/model/pipeline/parameter-config';
import { FilePath } from 'app/model/dataset/file-path';
import { format } from 'app/shared/utils/string.util';
import { validateFilePath } from 'app/shared/utils/activity-validation.util';

@Metamodel.model({
    name: ModelConstants.usqlActivity,
    display: [
        format(stringResources.ModelName_ActivityTemplate, stringResources.USqlActivityLabel),
        format(stringResources.ModelName_ActivitiesTemplate, stringResources.USqlActivityLabel)
    ],
    referable: true
})
export class USqlActivity extends ScriptFlowActivity {
    public static readonly MODEL: IModel;
    public static readonly SCRIPT_PATH: IAttribute;
    public static readonly DEGREE_OF_PARALLELISM: IAttribute;
    public static readonly PRIORITY: IAttribute;
    public static readonly RUNTIME_VERSION: IAttribute;
    public static readonly COMPILATION_MODE: IAttribute;

    @Metamodel.attribute({
        display: stringResources.ModelName_UsqlScriptPath,
        constraint: {
            validator: USqlActivity.validateScriptPath,
            required: true
        },
        templatable: true,
        accepts: ['String'],
        association: 'SCRIPT_PATH'
    })
    public scriptPath: FilePath = new FilePath();

    @Metamodel.attribute({
        display: stringResources.ModelName_DegreeOfParallelism,
        templatable: true,
        association: 'DEGREE_OF_PARALLELISM'
    })
    public degreeOfParallelism?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Priority,
        templatable: true,
        association: 'PRIORITY'
    })
    public priority?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_RuntimeVersion,
        templatable: true,
        association: 'RUNTIME_VERSION'
    })
    public runtimeVersion?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_CompilationMode,
        templatable: true,
        association: 'COMPILATION_MODE'
    })
    public compilationMode?: 'Semantic' | 'Full' | 'SingleBox';

    @Metamodel.attribute({
        display: stringResources.Parameters,
        constraint: {
            validator: createParameterConfigurationValidator()
        }
    })
    public parameters?: ParameterConfig[];

    @Metamodel.attribute({
        display: stringResources.ModelName_ADLAAccount,
        constraint: {
            required: true
        },
        reference: true,
        type: AzureDataLakeAnalyticsLinkedService.MODEL
    })
    public linkedService?: AzureDataLakeAnalyticsLinkedService;

    constructor(name?: string, description?: string) {
        super(name, description);
        this.activityType = 'ExecutionActivity';
    }

    private static validateScriptPath(_activity?: USqlActivity, arg?: FilePath): IViolation[] {
        return validateFilePath(_activity, arg, USqlActivity.SCRIPT_PATH);
    }

    public getFullScriptPath(): string {
        return this.scriptPath ? this.scriptPath.path || '' : '';
    }
}
